/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
class MarketsDropdown extends HTMLElement {
  constructor() {
    super();
    this.markets = window.markets || [];
    this.list = this.querySelector('ul');
    this.setMarketsOptions();
    this.links = this.querySelectorAll('a[data-custom-market]');
    this.toogleBtn = this.querySelector('button[data-popout-toggle]');
    this.setEventListeners();
  }

  setMarketsOptions() {
    let html = '';
    this.markets.forEach((market) => {
      html += `<li class="select-popout__item">
        <a class="select-popout__option" href="#" data-custom-market="${market.marketURL}">
          <span>${market.countyCode}</span>
        </a>
      </li>`;
    });

    this.list.insertAdjacentHTML('beforeend', html);
    const listItemsArr = Array.from(this.list.querySelectorAll('li'));
    listItemsArr
      .sort((a, b) => a.querySelector('span').textContent.localeCompare(b.querySelector('span').textContent))
      .forEach((el, idx) => {
        // eslint-disable-next-line no-param-reassign
        el.style.order = idx;
      });
  }

  setEventListeners() {
    this.links.forEach((link) => link.addEventListener('click', this.onLinkClick.bind(this, link)));
  }

  onLinkClick(link) {
    const marketURL = link.dataset.customMarket;
    const marketsPopup = document.querySelector('markets-popup');
    if (marketsPopup) {
      this.toogleBtn.click();
      marketsPopup.open(marketURL);
    } else {
      window.location = marketURL;
    }
  }
}

customElements.define('markets-dropdown', MarketsDropdown);

class MarketsPopup extends HTMLElement {
  constructor() {
    super();

    this.customPopup = new window.theme.CustomPopup(this);
  }

  open(url) {
    this.querySelector('a').href = url;
    this.customPopup.showPopup();
  }
}

customElements.define('markets-popup', MarketsPopup);
